export const PAY_MEAN_CODE = {
  CARD: '11', //신용카드
  REAL_TIME_BANK: '12', //실시간계좌이체
  V_BANK: '13', //가상계좌
  SAMSUNG_WALLET: '14',
  HPP: '16', //핸드폰 소액결제
  HP: '19', // 핸드폰 결제
  TOSSPAYMENTS_TRANSFER: '07', // 토스페이먼츠 퀵계좌이체
  TOSSPAYMENTS_TOSSPAY: '08' //토스페이먼츠 토스페이  
};
